import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';
import { Location } from 'models/locations';

import LocationImage from 'components/location/image';

const propTypes = {
  location: PropTypes.instanceOf(Location).isRequired,
  booking: PropTypes.instanceOf(Booking).isRequired,
};

const PastBookingImage = ({ location, booking }) => {
  if (booking.onDemand) { return null; }

  return (
    <div className="col-sm-2 col-xs-5">
      <LocationImage location={location} type="thumbnail" />
    </div>
  );
};

PastBookingImage.propTypes = propTypes;
export default PastBookingImage;
